import { Transform } from "class-transformer";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { toEuros } from "@/utils/numberUtils";

export class SupplierInvoiceTaxLineDto extends BaseEntityDto {
  name: string;

  percentage: number;

  @Transform(({ value }) => toEuros(value))
  amount: number;

  supplierInvoiceId: string;
}
